var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"input-filter",attrs:{"label":"Buscar","hide-details":"","solo":"","outlined":"","flat":"","dense":"","height":"28px"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }